import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[sidenavContentArea]',
    standalone: false
})
export class SidenavContentAreaDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
